import { render } from "./gzhNewsDetails.vue?vue&type=template&id=2cb49787"
import script from "./gzhNewsDetails.vue?vue&type=script&lang=js"
export * from "./gzhNewsDetails.vue?vue&type=script&lang=js"

import "./gzhNewsDetails.vue?vue&type=style&index=0&id=2cb49787&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__